import { useEffect } from 'react'

export const useEscapeKey = (onEscape: () => void, enabled = true) => {
    useEffect(() => {
        if (!enabled) return

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key !== 'Escape') return
            onEscape()
        }

        document.addEventListener('keydown', handleKeyDown)
        return () => document.removeEventListener('keydown', handleKeyDown)
    }, [enabled, onEscape])
}
